import type { SeoMeta } from '@dma/types';

/**
 * SEO metadata for pages with no per-entity `seo: SeoMeta` field of their
 * own (unlike Project/Service/Mineral, whose entities already carry one —
 * see their content/*.content.ts files). Every description below is derived
 * from real copy already written for that page (home.content.ts,
 * about.content.ts, company-info.content.ts), not new marketing text —
 * this file only decides what subset becomes the meta description.
 */
export const staticSeo = {
  home: {
    title: 'داریوش معدن آذر',
    description:
      'شرکت داریوش معدن آذر — فعالیت حرفه‌ای در اکتشاف، استخراج، فرآوری و توسعه پروژه‌های معدنی.'
  },
  about: {
    title: 'درباره ما',
    description:
      'داریوش معدن آذر در سال ۱۴۰۰ با هدف فعالیت حرفه‌ای، توسعه‌محور و بلندمدت در صنعت معدن و صنایع معدنی تأسیس شد.'
  },
  contact: {
    title: 'تماس با ما',
    description: 'راه‌های ارتباط با داریوش معدن آذر: آدرس دفتر مرکزی، تلفن، واتساپ، ایمیل و ساعات کاری.'
  },
  gallery: {
    title: 'گالری تصاویر و ویدیو',
    description: 'گالری تصاویر و ویدیوهای معادن، محدوده‌های اکتشافی و پروژه‌های صنعتی داریوش معدن آذر.'
  },
  projectsList: {
    title: 'پروژه‌ها و معادن',
    description: 'معادن و محدوده‌های اکتشافی داریوش معدن آذر، از پروانه بهره‌برداری تا مراحل اکتشاف.'
  },
  servicesList: {
    title: 'خدمات',
    description: 'خدمات داریوش معدن آذر در اکتشاف، زمین‌شناسی، استخراج، فرآوری و توسعه پروژه‌های معدنی.'
  },
  mineralsList: {
    title: 'محصولات و مواد معدنی',
    description: 'کاتالوگ محصولات معدنی داریوش معدن آذر.'
  },
  mineralogyList: {
    title: 'کانی‌شناسی',
    description: 'مطالب علمی کانی‌شناسی داریوش معدن آذر.'
  },
  petrologyList: {
    title: 'سنگ‌شناسی',
    description: 'مطالب علمی سنگ‌شناسی داریوش معدن آذر.'
  },
  adminGeneric: {
    title: 'پنل مدیریت',
    description: 'پنل مدیریت داریوش معدن آذر.'
  }
} as const satisfies Record<string, SeoMeta>;
